import './App.css';
import ExportCandidateComponent from './components/candidate/candidate';
import SearchCandidateComponent from './components/candidate/searchcandidate';
import DashboardComponent from './components/dashboard/dashboard';
import LoginComponent from './components/login/Login';
import ErrorComponent from './components/error/error';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from './components/http/authcontex';
import DisplayImageComponent from './components/candidate/displayimage';
import ShowUsers from './components/user/showUser';
import ManageBatchForm from './components/managebatch/manageBatch';
import ShowProjectsInManageBatch from './components/managebatch/ShowProjects';
import ShowProjectBatchas from './components/managebatch/ShowBatchas';
import UserForm from './components/user/userForm';
import AddProjectForm from './components/project/editProject';
import EvidenceForm from "./components/evidence/EvidenceForm";
import ShowProjects from './components/project/project';
import ShowEvidence from "./components/evidence/ShowEvidence";
import EnrollProjects from './components/project/EnrollProjects';
import ManageCandidate from "./components/candidate/ManageCandidate";
import AddCandidate from './components/candidate/AddCandidate';




function RoutAuth({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/displayImage" element={<DisplayImageComponent />} />

            <Route path="/dashboard" element={
              <RoutAuth><DashboardComponent /></RoutAuth>
            } />
            <Route path="/search" element={
              <RoutAuth><SearchCandidateComponent /></RoutAuth>
            } />
            <Route path="/export" element={
              <RoutAuth><ExportCandidateComponent /></RoutAuth>
            } />
            <Route path="/project" element={
              <RoutAuth><ShowProjects /></RoutAuth>
            } />
            <Route path="/managebatch" element={
              <RoutAuth><ShowProjectsInManageBatch /></RoutAuth>
            } />
            <Route path="/managebatch/:projectId" element={
              <RoutAuth><ShowProjectBatchas /></RoutAuth>
            } />
            <Route path="/addBatch/:projectId" element={
              <RoutAuth><ManageBatchForm mode="add" /></RoutAuth>
            } />
            <Route path="/editBatch/:projectId/:id" element={
              <RoutAuth><ManageBatchForm mode="edit" /></RoutAuth>
            } />
            <Route path="/editProject" element={
              <RoutAuth><AddProjectForm mode="add" /></RoutAuth>
            } />
            <Route path="/editProject/:id" element={
              <RoutAuth><AddProjectForm mode="edit" /></RoutAuth>
            } />
            <Route path="/users" element={
              <RoutAuth><ShowUsers /></RoutAuth>
            } />
            <Route path="/users/add" element={
              <RoutAuth><UserForm mode="add" /></RoutAuth>
            } />
            <Route path="/users/edit/:id" element={
              <RoutAuth><UserForm mode="edit" /></RoutAuth>
            } />
            <Route path="/evidence/:batchId" element={
              <RoutAuth><EvidenceForm /></RoutAuth>
            } />
            <Route path="/batch/:batchId/evidence" element={
              <RoutAuth><EvidenceForm /></RoutAuth>
            } />
            <Route path="/editEvidence/:batchId/:evidenceId" element={
              <RoutAuth><EvidenceForm /></RoutAuth>
            } />
            <Route path="/evidence/batch/:batchId" element={
              <RoutAuth><ShowEvidence /></RoutAuth>
            } />
            <Route path="*" element={<ErrorComponent />} />
            <Route path="/enroll" element={
              <RoutAuth><EnrollProjects /></RoutAuth>
            } />

            <Route path="/addCandidate/:projectId" element={
              <RoutAuth><AddCandidate/></RoutAuth>
            } />
            <Route path="/editCandidate/:projectId/:aadharNumber" element={<AddCandidate />} />

            <Route path="/manageCandidates/:projectId" element={<ManageCandidate />} />

          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
